import React from "react";
import { ApartmentExtra, ReservationExtra } from "../../../utils/api/apartmentRentalsAPI";
import { fmtAmount } from "./bookingPricing";

interface Props {
  extras: ApartmentExtra[];
  selectedExtras: ReservationExtra[];
  toggleExtra: (extra: ApartmentExtra) => void;
  updateExtraQty: (extraId: string, qty: number) => void;
  currency?: string;
  title: string;
}

const ExtrasBlock: React.FC<Props> = ({ extras, selectedExtras, toggleExtra, updateExtraQty, currency, title }) => (
  <div className="pab-extras-block">
    <div className="pab-block-title">{title}</div>
    <div className="pab-extras-list">
      {extras.map((extra) => {
        const eid = extra._id || extra.name;
        const sel = selectedExtras.find((e) => e.extraId === eid);
        const activePrice = extra.discountedPrice != null ? extra.discountedPrice : extra.regularPrice;
        return (
          <div
            key={eid}
            className={`pab-addon${sel ? " pab-addon--checked" : ""}`}
            onClick={() => toggleExtra(extra)}
          >
            <span className="pab-addon__check" aria-hidden>
              {sel ? "✓" : ""}
            </span>
            <div className="pab-addon__body">
              <div className="pab-addon__title">{extra.name}</div>
              <div className="pab-addon__price">
                {extra.discountedPrice != null && (
                  <span className="pab-addon__price-old">{fmtAmount(extra.regularPrice, currency)}</span>
                )}
                <span className={extra.discountedPrice != null ? "pab-addon__price-now" : undefined}>
                  {fmtAmount(activePrice, currency)}
                </span>
                {extra.unit && <span className="pab-addon__unit"> {extra.unit}</span>}
              </div>
            </div>
            {sel && (
              <div className="pab-stepper pab-stepper--sm" onClick={(e) => e.stopPropagation()}>
                <button type="button" className="pab-stepper__btn" onClick={() => updateExtraQty(eid!, Math.max(1, sel.quantity - 1))}>−</button>
                <span className="pab-stepper__value">{sel.quantity}</span>
                <button type="button" className="pab-stepper__btn" onClick={() => updateExtraQty(eid!, sel.quantity + 1)}>+</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default ExtrasBlock;
